<template>
    <v-dialog v-model="show" max-width="900px">
      <v-card class="privacy-modal">
        <v-card-title class="modal-title">
          CONTACTO
          <v-btn icon @click="$emit('close')" class="close-button ">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="privacy-content" @scroll="onScroll">
        <br/>
        <p><a href="mailto:info@matchcalendars.com">info@matchcalendars.com</a></p>
        </v-card-text>
        <v-card-actions class="d-flex d-md-none justify-center pt-2 pb-4">
          <v-row>
            <v-col cols="12" align="center" justify="center">
              <v-btn color="error" @click="$emit('close')" block>
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'ContactoModal',
  props: {
    show:{
        typeof: Boolean, default: true
    }
  },
  watch:{
    show:{
        immediate: true,
        handler(val){
            if(val == false)
                this.$emit('close')
        }
    }
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      document.querySelector('.privacy-content').classList.toggle('scrolled', scrollTop + clientHeight >= scrollHeight);
    }
  }
}
</script>

<style scoped>
.privacy-modal {
  border-radius: 10px;
  overflow-y: auto;
  max-height: 85vh;
}

.close-button {
  color: black;
}

.index ol {
  padding-left: 20px;
}

.index a {
  color: #6A1B9A;
  text-decoration: none;
}
</style>
